import styled from 'styled-components'
import { respondTo } from '../../../../../styles/_respondTo'

export const UlStyled = styled.ul`
  padding: 10px;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
`

export const LiStyled = styled.li`
  list-style: none;
  color: ${props => props.color || "#707070"};
  font-weight: bold;

  ${respondTo.lg`
    font-size: 1.3rem;
  `}

`